import { render } from "./PriceListProductBuilderModal.vue?vue&type=template&id=0a590a42&scoped=true"
import script from "./PriceListProductBuilderModal.vue?vue&type=script&lang=js"
export * from "./PriceListProductBuilderModal.vue?vue&type=script&lang=js"

import "./PriceListProductBuilderModal.vue?vue&type=style&index=0&id=0a590a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a590a42"]])

export default __exports__